<template>
  <div class="goods_combine">
    <div class="contain">
      <div class="search_box">
        <top-title :classType="1" :name="name"></top-title>
        <div style="margin-top: 20px">
          <input-form ref="inputForm" :pageName="pageName" @toParentVal="searchForm" :inputData="inputData"></input-form>
        </div>
      </div>
      <div class="tab_box">
        <!-- 按钮 -->
        <div class="btn_all">
          <div class="left" style="display: inline-flex;align-items: center;">
            <div class="btn" v-zoom="{ from: pageName, name: '批量营销' }" @click="piLiang()">
              <span class="btn_tit">批量营销</span>
            </div>
            <div @click="seacherResultCare" v-zoom="{ from: pageName, name: '导出' }" class="btn2 btn">
              <span class="status_btn3">导出</span>
            </div>
            <span style="color:rgb(254, 77, 69);padding-right:20px">注意：如添加监控的商品连带率小于5%则页面不显示，或调整查询区的付款时间后查询查看；</span>
          </div>
          <div class="right">
            <el-tooltip class="item" effect="light" content="手动添加的监控商品次日在列表中显示" placement="top-start">
              <span class="question_icon">?</span>
            </el-tooltip>
            <span style="padding-right: 12px; margin-left: 4px"
              >共<span class="num"> 100 </span>个监控位，已用<span class="num" style="padding-right: 4px; margin-left: 4px">{{ count }}</span
              >个</span
            >
            <el-button class="status_btn3 status_btn" v-zoom="{ from: pageName, name: '添加监控' }" @click="addMonitor">添加监控</el-button>
          </div>
        </div>
        <div>
          <el-table
            :data="tableData"
            style="width: 100%; margin-top: 22px"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            row-key="itemBindsellAnalyzeId"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column prop="mainItemTitleStr" min-width="140" label="买了A商品(前项商品)">
              <template slot-scope="scope">
                <span>{{ scope.row.mainItemTitleStr }}</span>
                <br />
                <span>{{scope.row.mainNumIidStr != ''?'SKU ID：':''}}{{ scope.row.mainNumIidStr }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mainBuyerCountStr" label="人数"></el-table-column>
            <el-table-column prop="subItemTitle" min-width="140" label="还买了B商品(后项商品)">
              <template slot-scope="scope">
                <span>{{ scope.row.subItemTitle }}</span>
                <br />
                <span>SKU ID：{{ scope.row.subNumIid }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="subBuyerCount" label="人数"></el-table-column>
            <el-table-column prop="bindPercent" label="购买连带率">
              <template slot="header">
                <div>
                  购买连带率
                  <el-tooltip class="item" effect="light" content="连带率=B商品人数/A商品人数*100%" placement="top-start">
                    <!-- <i class="el-icon-question tips" ></i> -->
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div>{{ bindPercent(scope.row.bindPercent) }}%</div>
              </template>
            </el-table-column>
            <el-table-column prop="recommendCount" label="可推荐人数">
              <template slot="header">
                <div>
                  可推荐人数
                  <el-tooltip class="item" effect="light" content="买了A商品但未购买B商品的" placement="top-start">
                    <!-- <i class="el-icon-question tips" ></i> -->
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div>{{ scope.row.recommendCount }}</div>
                <div v-zoom="{ from: pageName, name: '立即营销' }" @click="InstantMarketing(scope.row)" class="edit_btn">
                  立即营销
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="successCount" label="预计成功人数"></el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div>{{ scope.row.type | typeStr }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
                                <el-button type="text" @click="delteItem(scope.row)" :style="{'color':'#f56c6c'}">删除</el-button>-->
                <template v-if="scope.row.type == 1">
                  <span @click="monitorCancel(scope.row)" v-zoom="{ from: pageName, name: '取消监控' }" type="text" class="edit_btn">取消监控</span>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              padding: 20px 28px 30px;
              text-align: right;
              margin-bottom: 0px;
            "
          >
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 50, 100, 500, 1000]"
              :total="paginationForm.totalCount"
              :page-size="paginationForm.pageSize"
              :current-page="paginationForm.page"
              @size-change="handleSizeChangeSms"
              @current-change="handleCurrentChangeSms"
            ></el-pagination>
          </div>
          <!-- <pagination
            @transferName="CurrentChange"
            :total="paginationForm.totalCount"
          ></pagination> -->
        </div>
      </div>
    </div>
    <!-- 选择商品弹框 -->
    <select-goods
      v-show="goodsState"
      :skuSearch="true"
      :isShow="goodsState"
      :moduleType="true"
      :selectGoods="returnSelectGoods"
      @close="selectGoodsChange"
    ></select-goods>
    <!-- 批量发送短信抽屉 -->
    <!-- <send-sms :drawer="drawer" @close="drawerClose"></send-sms> -->

    <!-- 批量发送短信抽屉 -->
    <send-sms
      :drawer="drawer"
      @close="drawerClose"
      :checkData="checkData"
      taskName="商品销售连带分析"
      :sendType="2"
      :count="checkCount"
      :dataFrom="loginUserInfo.venderType?2:1"
      :searchForm="searchFormData"
    >
    </send-sms>

     <!-- 生成报表 -->
     <generate :control = 'control' 
               v-if="control" 
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'
               ></generate>



  </div>
</template>

<script>
import { bindSell, delBindsell, addBindsell, getBindPhones, count } from "@/api/analysis/ware-controller";
import { mapState, mapMutations, mapGetters } from "vuex";
import SelectGoods from "@/components/selectGoodsMonitor";
// import sendSms from "@/views/serviceCenter/send_sms";
import sendSms from "@/views/serviceCenter/components/sendSms";
import topTitle from "@/components/top-title";
import inputForm from "@/components/inputForm";
import generate from '../../components/generate_report.vue'
// import Pagination from "@/components/pagination";
import qs from "qs";
export default {
  components: {
    topTitle,
    inputForm,
    sendSms,
    SelectGoods,
    generate 
  },
  data() {
    return {
      control:false,
      pageName: "数据分析-商品销售连带分析",
      drawer: false, // 发送短信抽屉状态控制
      checkData: [],
      checkCount: 0,
      searchFormData: {},

      tableLoading: false,
      rowSpanArr: [],
      returnSelectGoods: [],
      multipleSelection: [],
      multipleSelection2: [],
      form: {},
      count: "",
      goodsState: false,
      paginationForm: {
        totalCount: 0,
        page: 1,
        pageSize: 10,
      },
      // 表单项
      inputData: [
        {
          name: "购买连带率:",
          iptArr: [
            { val: "bindPercentStart", placeholder: "请输入" },
            { val: "bindPercentEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "可推荐人数:",
          iptArr: [
            { val: "recommendCountStart", placeholder: "请输入" },
            { val: "recommendCountEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "预计成功数:",
          iptArr: [
            { val: "successCountStart", placeholder: "请输入" },
            { val: "successCountEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "后项商品数:",
          val: "shopSelect",
          // width:120,
          selectArr: [
            { id: "", label: "全部" },
            { id: 1, label: 1 },
            { id: 2, label: 2 },
            { id: 3, label: 3 },
            { id: 4, label: 4 },
            { id: 5, label: 5 },
          ],
        },
        {
          name: "前项商品:",
          val: "mainInput",
          // width:125,

          placeholder: "请输入商品sku id",
        },
        {
          name: "后项商品:",
          val: "subInput",
          // width:125,
          placeholder: "请输入商品sku id",
        },
        {
          name: "类型:",
          // width:120,
          val: "type",
          selectArr: [
            { id: "", label: "全部" },
            { id: 0, label: "系统" },
            { id: 1, label: "自定义" },
          ],
        },
        {
          name: "付款时间:",
          val: "timeScope",
          default: 2,
          radioArrShow:true,
          radioArr: [
            { val: "近7天", label: 2 },
            { val: "近15天", label: 3 },
            { val: "近30天", label: 4 },
            { val: "近90天", label: 5 },
            { val: "近180天", label: 6 },
            // {val:'自定义：',label:'custom',
            //     children:[
            //         {
            //             myDate: true,
            //             val: ['timeScopeStart', 'timeScopeEnd'],
            //             startPlaceholder: '开始日期',
            //             endPlaceholder: '结束日期'
            //         },
            //     ]
            // },
          ],
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),

    name() {
      return this.$route.name;
    },
    headItem() {
      return this.$store.state.route;
    },
    bindPercent() {
      return function(val) {
        if (val == 0) {
          return 0;
        }
        let num = val * 100 + "";
        console.log(num);
        if (num.indexOf(".") != -1) {
          let num1 = num.substring(0, num.indexOf("."));
          let num2 = num.substring(num.indexOf("."), num.indexOf(".") + 2);
          return num1 + num2;
        }
        return num;
        // let num1 =

        // let num = val*100+"";
        // return val?num1 + num.slice(num.indexOf('.'),num.indexOf('.')+2):''
      };
    },
  },
  created() {
    count().then((res) => {
      this.count = res.data;
    });

    // 埋点
    this.buriedPoint(1, '商品销售连带分析', '数据分析', '商品分析')
  },
  mounted() {
    this.$refs.inputForm.formSearch();
    // this.getRowSpan()
  },
  filters: {
    typeStr(type) {
      return { 0: "系统", 1: "自定义" }[type];
    },
  },
  methods: {
    /**
     * 发送短信抽屉隐藏
     */
    drawerClose() {
      this.drawer = false;
    },

    handleSizeChangeSms(val) {
      this.paginationForm.pageSize = val;
      this.paginationForm.page = 1;
      this.$refs.inputForm.formSearch();
    },
    handleCurrentChangeSms(val) {
      this.paginationForm.page = val;
      this.$refs.inputForm.formSearch();
    },
    // 合并相同A商品列
    getRowSpan() {
      this.rowSpanArr = [];
      this.tableData.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].mainItemTitle == this.tableData[index - 1].mainItemTitle) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.tableData[index].mainItemTitle = this.tableData[index - 1].mainItemTitle;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
      console.log(this.rowSpanArr);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex);
      if (columnIndex === 0 || columnIndex === 1) {
        const _row = this.rowSpanArr[rowIndex];
        return {
          rowspan: _row, //行
          colspan: 1, //列
        };
      }
    },
    // 导出
    seacherResultCare() {
      this.control = true;
    },
    getphone1(val){
      this.form.exportRemark = val
      this.$http.post("/ware/export/bindSell", this.form).then((res) => {
         if(res.data.code==1){
           this.control = true;
         }else {
          this.$message.error(res.data.message);
         }
      });
    },
    /**
     * 表单查询
     */
    searchForm(form) {
      this.tableLoading = true;
      this.form = form;
      let params = {
        bindPercentStart: form.bindPercentStart,
        bindPercentEnd: form.bindPercentEnd,
        recommendCountStart: form.recommendCountStart,
        recommendCountEnd: form.recommendCountEnd,
        successCountStart: form.successCountStart,
        successCountEnd: form.successCountEnd,
        timeScope: form.timeScope,
        type: form.type,
        subSkuId: form.subInput,
        // mainSkuId : form.mainInput
        mainSkuId: form.mainInput,
        current: this.paginationForm.page,
        size: this.paginationForm.pageSize,
      };

      bindSell({
        // ...form,
        ...params,
        // ...this.paginationForm,
      }).then((res) => {
        this.tableLoading = false;
        this.tableData = [];
        res.data.records.map((item, index) => {
          item.skuBindSellVOList.map((items, indexs) => {
            if (indexs == 0) {
              items.mainItemTitleStr = items.mainItemTitle || ''
              items.mainBuyerCountStr = items.mainBuyerCount || ''
              items.mainNumIidStr = items.mainNumIid || ''
              this.tableData.push(items);
              this.tableData[index].children = [];
            } else {
              items.mainItemTitleStr = ''
              items.mainBuyerCountStr = ''
              items.mainNumIidStr = ''
              this.tableData[index].children.push(items);
            }
          });
        });
        console.log('this.tableData',this.tableData);
        this.paginationForm.totalCount = res.data.total;
      });
    },
    showSelectGoods() {
      this.selectLoading = true;
      this.goodsState = true;
    },
    /*
     * 关闭指定商品弹窗
     * */
    selectGoodsChange(val) {
      console.log("商品选择返回==", val);
      this.goodsState = false;
      if (val !== false) {
        console.log("商品选择返回==222");
        // this.returnSelectGoods = val;
        let arr = val.map((item) => {
          return {
            jdPrice: item.jdPrice,
            logo: item.logo,
            skuId: item.skuId,
            skuName: item.wareTitle,
          };
        });
        addBindsell(arr).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");

            this.$refs.inputForm.formSearch();
            count().then((res) => {
              this.count = res.data;
            });
          }else{
            this.$message.error(res.message);
          }
        });
        console.log(val);
      }
    },
    addMonitor() {
      // this.selectGoodsDialog = true
      this.showSelectGoods();
    },
    /**
     * 分页查询
     */
    CurrentChange(event) {
      this.leftPaginationInfo.current = event.current;
      this.leftPaginationInfo.pageSize = event.pageSize;
      this.$refs.inputForm.formSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    piLiang() {
      if (this.multipleSelection.length == 0 || this.multipleSelection.length == 0) {
        this.$message.error("您还未勾选，请进行勾选，再继续操作!");
        return;
      }

      let arr = [...this.multipleSelection, ...this.multipleSelection2];
      let ids = arr.map((i) => i.itemBindsellAnalyzeId).join(",");
      getBindPhones({ itemIds: ids }).then((res) => {
        if (res.code == 1) {
          // window.localStorage.setItem("mobile", res.data.join(","));
          var list = res.data;
          this.checkData = list;
          this.checkCount = list.length;
          // 跳转到客户营销-指定号码发送
          this.drawer = true;
          // let routeUrl = this.$router.resolve({
          //   path: "/marketing/marketing/designated_send",
          //   query: { id: 78 },
          // });
          // window.open(routeUrl.href, "_blank");
        }
      });
    },
    monitorCancel(item) {
      console.log(item);
      // return
      delBindsell(item.mainNumIid).then((res) => {
        if (res.code == 1) {
          this.$message.success("已取消监控");
          this.$refs.inputForm.formSearch();
          count().then((res) => {
            this.count = res.data;
          });
        }
      });
    },
    // 立即营销
    InstantMarketing(item) {
      // let params = qs.stringify({ itemIds:item.phoneToRecommend},{arrayFormat:'repeat'})
      // return
      getBindPhones({ itemIds: item.itemBindsellAnalyzeId }).then((res) => {
        if (res.code == 1) {
          // 号码存入localStorage
          // window.localStorage.setItem("mobile", res.data.join(","));
          // 跳转到客户营销-指定号码发送
          var list = res.data;
          this.checkData = list;
          this.checkCount = list.length;
          this.drawer = true;
          // let routeUrl = this.$router.resolve({
          //   path: "/marketing/marketing/designated_send",
          //   query: { id: 78 },
          // });
          // window.open(routeUrl.href, "_blank");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table__expanded-cell {
  padding: 0;
}
.goods_combine {
  margin-top: 10px;
  // font-family: PingFang SC;
  .edit_btn {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .contain {
    box-sizing: border-box;
    padding: 0 20px;
    min-width: 1106px;
    .search_box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 0px 0 30px 0;
      border-radius: 6px;
    }
    .tab_box {
      margin-top: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 20px;
      border-radius: 6px;
      .btn_all {
        display: flex;
        // padding: 0 20px;
        justify-content: space-between;
        .btn {
          box-sizing: border-box;
          float: left;
          // display: inline-block;
          vertical-align: middle;
          // padding: 5px 16px;
          font-size: 14px;
          border-radius: 3px;
          margin-right: 8px;
          width: 98px;
          height: 32px;
          cursor: pointer;
          background: #fe4d45;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          // line-height: 20px;
          .btn_tit {
            vertical-align: middle;
            padding: 7px 20px;
            width: 98px;
            font-size: 14px;
            height: 32px;
            color: #ffffff;
            border-radius: 3px;
            border: 1px solid #fe4d45;
            background-color: #fe4d45;
            &:hover {
              color: #fff;
              opacity: 0.9;
              background-color: #fe4d45;
            }
            &:active {
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff4f4;
            }
          }
        }
        .btn2 {
          background: #fff;
          // border: 1px solid rgba(0, 0, 0, 0.15);
        }
        .status_btn {
          width: 98px;
          height: 32px;
          background-color: #fff;
          font-size: 14px;
        }
        .status_btn2 {
          margin-left: 20px;
          color: #fe4d45;
          vertical-align: middle;
        }
        .status_btn3 {
          width: 98px;
          padding: 7px 32px;
          height: 32px;
          color: #666666;
          border-radius: 3px;
          border: 1px solid #dddddd;
          background-color: #fff;
          &:hover {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
        .right {
          font-size: 14px;
          color: #666;
          .num {
            color: #fe4d45;
          }
        }
      }
      .question_icon {
        width: 14px;
        height: 14px;
        color: #ccc;
        display: inline-block;
        line-height: 12px;
        text-align: center;
        border-radius: 14px;
        border: 1px solid #ccc;
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
}
/deep/.el-table__expand-icon{
  .el-icon-arrow-right{
    color: red;
    font-weight: 600;
    font-size: 17px;
  }
}
</style>
